<template>
    <div>
        <b-tabs v-model="activeTab">
            <b-tab-item label="Detalles de producto">
                <ProductDetailForm
                :productDetailEndpoint="productDetailEndpoint"
                :taxEndpoint="taxEndpoint"
                :currencyEndpoint="currencyEndpoint"
                :subcategoryEndpoint="subcategoryEndpoint"
                :details="productDetails"
                :loading="productLoading"
                :searchSub="productSearchSub"
                :filterOptions="accurateFilterOptions"
                @getProd="fetchDetails"/>
            </b-tab-item>
            <b-tab-item label="Imagenes">
                <ImagesForm
                :imagesUpdate="imagesUpdate"
                :imagesList="imagesList"
                :imagesCreate="imagesCreate"
                :imagesDelete="imagesDelete"/>
            </b-tab-item>
            <b-tab-item v-if="!productDetails.classified" label="Atributos">
                <AttrForm 
                :attributesList="attributesList"
                :attributesDetail="attributesDetail"
                :attributes="attributes"
                :attrValDetail="attrValDetail"
                :attrValCreate="attrValCreate"
                :attrandvalCreate="attrandvalCreate"
                @getProd="fetchDetails"
                @reFetchAttrs="fetchAttributes"/>
            </b-tab-item>
            <b-tab-item v-if="!productDetails.classified && varControler" label="Variantes">
                <VariantsForm
                :attributesList="attributesList"
                :variantList="variantList"
                :variantDetail="variantDetail"
                :variantCreate="variantCreate"
                :attributes="attributes"
                :variants="variants"
                @getprod="fetchDetails"
                @reFetchVariants="fetchVariants"/>
            </b-tab-item>
            <b-tab-item v-if="!productDetails.classified && stockControler" label="Inventario">
                <Inventory
                :movementList="movementList"
                :skuList="skuList"
                :skuCreate="skuCreate"
                :movementAdd="movementAdd"
                :movementDestroy="movementDestroy"
                :variants="variants"
                :totalStock="productDetails.getTotalStock"
                :micromanage="varControler"
                @getProd="fetchDetails"
                />
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
import ProductDetailForm from "./components/ProductDetailForm.vue"
import ImagesForm from "./components/ImagesForm.vue"
import AttrForm from "./components/AttrForm.vue"
import VariantsForm from "./components/VariantsForm.vue"
import Inventory from "./components/Inventory.vue"

import {getHandler} from "./../../../services/http.js"

export default {
    name:"ProductDetail",
    components:{
        ProductDetailForm,
        ImagesForm,
        AttrForm,
        VariantsForm,
        Inventory
    },
    props:{
        productDetailEndpoint:{
            type:String,
            default:""
        },
        taxEndpoint:{
            type:String,
            default:""
        },
        currencyEndpoint:{
            type:String,
            default:""
        },
        subcategoryEndpoint:{
            type:String,
            default:""
        },
        imagesList:{
            type:String,
            default:""
        },
        imagesCreate:{
            type:String,
            default:""
        },
        imagesDelete:{
            type:String,
            default:""
        },
        attributesList:{
            type:String,
            default:""
        },
        attributesDetail:{
            type:String,
            default:""
        },
        attrValDetail:{
            type:String,
            default:""
        },
        attrValCreate:{
            type:String,
            default:""
        },
        attrandvalCreate:{
            type:String,
            default:""
        },
        variantDetail:{
            type:String,
            default:""
        },
        variantCreate:{
            type:String,
            default:""
        },
        variantList:{
            type:String,
            default:""
        },
        movementList:{
            type:String,
            default:""
        },
        skuList:{
            type:String,
            default:""
        },
        skuCreate:{
            type:String,
            default:""
        },
        movementAdd:{
            type:String,
            default:""
        },
        movementDestroy:{
            type:String,
            default:""
        },
        imagesUpdate:{
            type:String,
            default:""
        },
        filtersEndpoint:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            activeTab: 0,
            attributes:[],
            variants:[],
            loading:false,
            trackStock:false,
            micromanage:false,
            productLoading:false,
            productDetails:{},
            productSearchSub:"",
            varControler:false,
            stockControler:false,
            allFilterOptions:[]
        }
    },
    computed:{
        accurateFilterOptions(){
            var filters = this.allFilterOptions.filter((el)=>{
                if (el.category == null){
                    return !el.category
                } else if (el.category == this.productDetails.category && this.productDetails.subcategory == null){
                    return el.category == this.productDetails.category && this.productDetails.subcategory == null
                } else if (el.subcategory == this.productDetails.subcategory){
                    return el.subcategory == this.productDetails.subcategory
                }
            })
            return filters
        }
    },
    methods:{
        async fetchAttributes(){
            let response = await getHandler(this.attributesList, {error:false, success:false})
            this.attributes = response
        },

        async fetchVariants(){
            this.loading = true
            let response = await getHandler(this.variantList, {error:false, success:false})
            this.variants = response
            this.loading = false
        },
        async fetchDetails(){
            this.productLoading = true
            var response = await getHandler(this.productDetailEndpoint, {success:false, error:false})
            this.productDetails = response
            this.productSearchSub = this.productDetails.subcategoryTitle
            this.varControler=this.productDetails.micromanage
            this.stockControler=this.productDetails.trackStock
            this.productLoading = false
        },

        async fetchFilters(){
            this.loading = true
            var url = this.filtersEndpoint + `?pagina_size=${10000}`
            var response = await getHandler(this.filtersEndpoint, {success:false, error:false})
            this.allFilterOptions = response.results
        }
    },
    created(){
        this.fetchDetails()
        this.fetchAttributes()
        this.fetchVariants()
        this.fetchFilters()
    }
}
</script>
<style lang="scss">
@import "./../../../scss/main.scss";
</style>